import React , {useState,useMemo,useEffect} from 'react'
import { useSelector } from "react-redux";
import clearFilter from '../assets/ClearFilter.svg'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { TbPointFilled } from "react-icons/tb";
import Pagination from '@mui/material/Pagination';
import NewDateandTimePicker from './NewDateandTimePicker';
import { useGetServiceDetailsDataQuery } from "../slices/getqueries/getqueriesApi";
import { format } from 'date-fns';
import { toast } from "react-toastify";
import Skeleton from '@mui/material/Skeleton';
import { formatINRCurrencyNoDecimals, formatINRCurrencyWithDecimals } from '../numberFormatter';


function ServiceDetails() {
  const { userInfo } = useSelector((state) => state.auth);
  const {clientId}=userInfo;
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const name= searchParams.get('name');
  const navigate = useNavigate();
  const [requestedIdInput, setRequestedIdInput] = useState('');
  const [statusInput, setStatusInput] = useState('');
  const [dateRangeInput, setDateRangeInput] = useState(null);
  const [requestedId, setRequestedId] = useState('');
  const [status, setStatus] = useState('');
  const [dateRange, setDateRange] = useState(null);

const handleApplyFilters = () => {
  const noFiltersSelected = !requestedIdInput && !dateRangeInput && !statusInput;

  if (noFiltersSelected) {
    handleResetFilters();
    return;
  }
  setRequestedId(requestedIdInput);
  setDateRange(dateRangeInput);
  setStatus(statusInput);
  setServicePage(1);
};
const handleResetFilters = async () => {
  setRequestedIdInput('');
  setStatusInput('');
  setDateRangeInput(null);

  setRequestedId('');
  setStatus('');
  setDateRange(null);
  setServicePage(1);
};
  const handleBack = () => {
    navigate(-1);
  };

  const [servicePage, setServicePage] = useState(1);
  const servicesEntriesPerPage = 15;
  const offset = (servicePage - 1) * servicesEntriesPerPage;
  
  const clientname = clientId;
  const groupId = key; 
 

  const queryParams = useMemo(() => {
    const baseParams = {
      clientname,
      groupId,
      limit: servicesEntriesPerPage,
      offset,
    };
  
    if (requestedId) baseParams.requestedId = requestedId;
    if (status) baseParams.status = status;
    if (dateRange) {
      baseParams.fromDate = format(dateRange[0], 'yyyy-MM-dd');
      baseParams.toDate = format(dateRange[1], 'yyyy-MM-dd');
    }
  
    return baseParams;
  }, [clientname, groupId, servicesEntriesPerPage, offset, requestedId, status, dateRange]);
  
  const {
    data: serviceData,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useGetServiceDetailsDataQuery(queryParams);
 
  const paginatedServices = useMemo(() => {
    if (!serviceData || !Array.isArray(serviceData.moduleData)) return [];
  
    return serviceData.moduleData.map((item) => {
      const [datePart, timePart] = item["transactiondate&time"].split(" ");
      return {
        id: item.requestId || "-",
        date: format(new Date(datePart), "dd MMM yyyy"),
        time: timePart?.slice(0, 8) || "-",
        creditleft: `₹${item.creditleft.toLocaleString('en-IN')}`,
        status: (item.status === 200 || item.status === 201) ? "Success" : "Failed",
      };
    });
  }, [serviceData]);
  
  console.log(paginatedServices)
  const totalServicePages = Math.ceil((serviceData?.totalCount || 0) / servicesEntriesPerPage);

  const handlePageChange = (event, value) => {
  setServicePage(value);
  };
  useEffect(() => {
    if (!isFetching) {
    if (serviceData) {
        toast.success("Data Fetched successfully!");
      }
    }
  }, [isError, isFetching, serviceData]);

  return (
    <>
<div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-y-3">
  
  <div className="flex items-center gap-3">
    <FaArrowLeftLong
      className="w-8 h-8 text-gray-700 hover:text-black transition cursor-pointer"
      onClick={handleBack}
    />
    <h1 className="font-semibold text-[20px] sm:text-[24px]">{name}</h1>
  </div>
       </div>
       <div className="flex flex-col md:flex-row md:justify-between md:items-center bg-[#204887] text-white p-6 rounded-[15px] mb-6">
  <div className="flex flex-col md:flex-row md:gap-[90px]">
    <div className='flex flex-row items-center justify-between gap-2 md:block'>
      <p className="text-[14px] font-[500] break-words md:mb-1">Service Charge Amount</p>
      <h2 className="text-[20px] font-[700] mt-1 break-all">{formatINRCurrencyWithDecimals(serviceData?.serviceChargeAmount)}</h2>
    </div>
    <div className='flex flex-row items-center justify-between gap-2 md:block mt-2 md:mt-0'>
      <p className="text-[14px] font-[500] break-words md:mb-1">Total Usage Count</p>
      <h2 className="text-[20px] font-[700] mt-1 break-all">{formatINRCurrencyNoDecimals(serviceData?.totalUsageCount)}</h2>
    </div>
    <div className='flex flex-row items-center justify-between gap-2 md:block mt-2 md:mt-0'>
      <p className="text-[14px] font-[500] break-words md:mb-1">Total Usage Amount</p>
      <h2 className="text-[20px] font-[700] mt-1 break-all">{formatINRCurrencyWithDecimals(serviceData?.totalUsageAmount)}</h2>
    </div>
  </div>
</div>
      <div className="flex flex-col lg:flex-row gap-6 w-full">
        
        <div className="bg-white rounded-[15px] shadow p-4 w-full lg:w-[20%]">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-[600] text-[20px]">Filters</h3>
            <img
              src={clearFilter}
              alt="Reset Filters"
              className="w-8 h-8 cursor-pointer"
              onClick={handleResetFilters}
              title="Clear Filters"
            />
          </div>
          <div className="space-y-4 md:grid md:grid-cols-2 md:items-end md:gap-3 lg:grid lg:grid-cols-1">

            <div className='space-y-4'>
            <p className='text-[#4B5563] font-[500] text-[12px]'>Requested Id</p>
            <input type="text" className="w-full border p-4 rounded-[10px] text-[#6B7280]" placeholder="Enter Requested Id" value={requestedIdInput} onChange={(e) => setRequestedIdInput(e.target.value)}/>
            </div>

            <div className="space-y-4">
            <p className='text-[#4B5563] font-[500] text-[12px]'>Transaction Date</p>
              <NewDateandTimePicker
                value={dateRangeInput}
                onDateRangeChange={(value) => setDateRangeInput(value)}
              />
            </div>

             <div className="space-y-4">
             <p className='text-[#4B5563] font-[500] text-[12px]'>Status</p>
             <select className="w-full border p-4 rounded-[10px] text-[#6B7280]" value={statusInput} onChange={(e) => setStatusInput(e.target.value)}>
              <option value="">Select status</option>
              <option>success</option>
              <option>fail</option>
            </select>
             </div>

            <div className='sm:w-[75%] md:w-[50%] lg:w-full'>
            <button className="w-full bg-[#204887] text-white py-4 rounded-[10px] mt-2 text-[12px]" onClick={handleApplyFilters}>Apply</button>
            </div>

          </div>
        </div>

        <div className="bg-white rounded-[15px] shadow p-4 overflow-auto w-full lg:w-[80%]">
  {isLoading ? (

    <table className="w-full min-w-[800px] text-[14px] rounded-[10px]">
      
      <thead className="bg-[#E5EFFF]">
        <tr>
          {['Requested Id', 'Transactions Date', 'Transactions Time', 'Credit Left', 'Status'].map(
            (h) => (
              <th key={h} className="customized-table-header text-[#204887]">
                {h}
              </th>
            )
          )}
        </tr>
      </thead>

      <tbody>
        {Array.from({ length: 5 }).map((_, row) => (
          <tr key={row}>
            {[...Array(5)].map((__, col) => (
              <td key={col} className="customized-table-value">
                <Skeleton animation="wave" height={20} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  ) : paginatedServices?.length === 0 ? (
 
    <div className="text-gray-600 flex items-center justify-center sm:mt-[8%] sm:mb-[8%] md:mt-[8%] md:mb-[8%] text-[15px] py-24">
      No Data Found
    </div>
  ) : (
   
    <>
      <table className="w-full min-w-[800px] text-[14px] rounded-[10px]">
        <thead className="bg-[#E5EFFF] text-[#204887]">
          <tr className="text-center font-semibold">
            <th className="customized-table-header">Requested Id</th>
            <th className="customized-table-header">Transactions Date</th>
            <th className="customized-table-header">Transactions Time</th>
            <th className="customized-table-header">Credit Left</th>
            <th className="customized-table-header">Status</th>
          </tr>
        </thead>
        <tbody>
          {paginatedServices.map((tx, index) => (
            <tr key={index}>
              <td className="customized-table-value break-words">{tx.id}</td>
              <td className="customized-table-value">{tx.date}</td>
              <td className="customized-table-value">{tx.time}</td>
              <td className="customized-table-value">{formatINRCurrencyWithDecimals(tx.creditleft)}</td>
              <td className="customized-table-value">
                <span
                  className={`flex items-center justify-center gap-1 px-3 py-2 rounded-full text-[10px] font-[600] ${
                    tx.status === 'Success'
                      ? 'bg-[#CAF1D8] text-[#0E4F26]'
                      : 'bg-[#FDD8D8] text-[#BF1D1D]'
                  }`}
                >
                  <TbPointFilled size={10} />
                  {tx.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {totalServicePages > 1 && (
        <div className="flex justify-center">
          <Pagination
            count={totalServicePages}
            page={servicePage}
            onChange={handlePageChange}
            showFirstButton
            showLastButton
            siblingCount={1}
            boundaryCount={1}
            color="primary"
            size="medium"
            sx={{
              '& li': { border: 'none', boxShadow: 'none', m: 0, p: 0 },
              '& .MuiPaginationItem-root': { fontSize: '1.2rem', fontWeight: 'bold' },
            }}
          />
        </div>
      )}
    </>
  )}
</div>

      </div>
    </>
  )
}

export default ServiceDetails
